export const filterData = [
    {
        title: "Meal Type",
        categoryName: "meal_type",
        options: [
            { label: "Breakfast", value: "breakfast" },
            { label: "Lunch", value: "lunch" },
            { label: "Dinner", value: "dinner" },
            { label: "Snack", value: "snack" },
            { label: "Brunch", value: "brunch" }
        ]
    },
    {
        title: "Budget",
        categoryName: "budget",
        options: [
            { label: "Under Ksh.500", value: "under_500" },
            { label: "Ksh.500 - Ksh.1000", value: "500_to_1000" },
            { label: "Ksh.1000 - Ksh.1500", value: "1000_to_1500" },
            { label: "Ksh.1500 and above", value: "above_1500" }
        ]
    },
    {
      title: "Cuisine",
      categoryName: "cuisine",
      options: [
        { label: "Indian", value: "indian" },
        { label: "Chinese", value: "chinese" },
        { label: "Italian", value: "italian" },
        { label: "Mexican", value: "mexican" },
        { label: "Japanese", value: "japanese" },
        { label: "Mediterranean", value: "mediterranean" },
        { label: "French", value: "french" }
      ]
    },
    {
      title: "Dietary",
      categoryName: "dietary",
      options: [
        { label: "Vegan", value: "vegan" },
        { label: "Vegetarian", value: "vegetarian" },
        { label: "Gluten Free", value: "gluten_free" },
        { label: "Keto", value: "keto" },
        { label: "Paleo", value: "paleo" },
        { label: "Dairy Free", value: "dairy_free" }
      ]
    },
    {
      title: "Method of Cooking",
      categoryName: "method_of_cooking",
      options: [
        { label: "Baked", value: "baked" },
        { label: "Grilled", value: "grilled" },
        { label: "Fried", value: "fried" },
        { label: "Boiled", value: "boiled" },
        { label: "Steamed", value: "steamed" },
        { label: "Microwaved", value: "microwaved" }
      ]
    },
    {
        title: "Course",
        categoryName: "course",
        options: [
            { label: "Appetizer", value: "appetizer" },
            { label: "Main Course", value: "main course" },
            { label: "Dessert", value: "dessert" },
            { label: "Soup", value: "soup" },
            { label: "Salad", value: "salad" },
            { label: "Side Dish", value: "side_dish" }
        ]
    },
    {
        title: "Ingredient",
        categoryName: "ingredient",
        options: [
            { label: "Chicken", value: "chicken" },
            { label: "Beef", value: "beef" },
            { label: "Pork", value: "pork" },
            { label: "Fish", value: "fish" },
            { label: "Vegetables", value: "vegetables" },
            { label: "Eggs", value: "eggs" },
            { label: "Cheese", value: "cheese" }
        ]
    },
    {
      title: "Cooking Time",
      categoryName: "cooking_time",
      options: [
        { label: "Under 30 minutes", value: "under_30" },
        { label: "30-60 minutes", value: "30_to_60" },
        { label: "More than 60 minutes", value: "over_60" }
      ]
    },
    {
        title: "Health Concerns",
        categoryName: "health_concerns",
        options: [
            { label: "Low Carb", value: "low carb" },
            { label: "Low Sugar", value: "low sugar" },
            { label: "Low Sodium", value: "low sodium" },
            { label: "High Protein", value: "high protein" }
        ]
    }
  ];
  